const getIsLoading = (state) => { return state.isLoading }

const getWithdrawsPaymentsList = (state) => { return state.withdrawPaymentsList }

const getWithdrawBookingsList = (state) => { return state.withdrawBookingsList }

const getAttractionsPaymentsList = (state) => { return state.attractionsPaymentsList }

const getCurrentWithdraw = (state) => { return state.currentWithdraw }

export default {
    getIsLoading,
    getWithdrawsPaymentsList,
    getWithdrawBookingsList,
    getAttractionsPaymentsList,
    getCurrentWithdraw,
}